import React from 'react';
import StepCounter from './signup/StepCounter';
import { IonicButton } from 'ionic-ui';
import { IonIcon } from '@ionic/react';
import { chevronBack } from 'ionicons/icons';
import { useHistory } from 'react-router';

type Props = {
  uiType: 'signup' | 'signin';
  title: string;
  description: string;
  totalSteps?: number;
  step?: number;
};

export default function AuthLayoutHeader({
  step,
  totalSteps,
  uiType,
  title,
  description,
}: Props) {
  const history = useHistory();
  const goBack = () => {
    if (uiType === 'signin') window.history.back();
    else history.goBack();
  };
  return (
    <div className="space-y-6">
      <div className="w-full h-10 flex items-center justify-center relative">
        {/* Back button */}
        <div className="max-w-md">
          <IonicButton
            onClick={goBack}
            type="button"
            variant="outline"
            className="w-10 h-10 px-0 pt-1 absolute top-0 left-0"
          >
            <IonIcon
              icon={chevronBack}
              className="text-inherit text-lg flex-grow"
            />
          </IonicButton>
        </div>
        <div className="w-full mx-10 ">
          <div className=" block dark:hidden">
            <img
              src="/images/swiftmedix-dark.svg"
              alt="Swiftmedix logo"
              className=" h-6 max-w-full block mx-auto "
            />
          </div>
          <div className=" dark:block hidden">
            <img
              src="/images/swiftmedix.svg"
              alt="Swiftmedix logo"
              className=" h-6 max-w-full  mx-auto"
            />
          </div>
        </div>
      </div>

      {/**Step counter */}
      {totalSteps && step && <StepCounter step={step} totalStep={totalSteps} />}

      {/**Heading */}
      <div className={`${uiType === 'signin' ? 'text-center' : ''} space-y-2`}>
        <h3 className={`high-emphasis-text font-bold font-parkinsans`}>
          {title}
        </h3>
        <h6 className="mb-6 medium-emphasis-text">{description}</h6>
      </div>
    </div>
  );
}
